import { Box, palette, Text } from '@solvhealth/jigsaw-v1';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import dataTestIds from '~/test/test-ids';
import { ModuleVariant } from '~/components/ClinicDetailPageFlexible/components/BookModule';
import Header from '~/components/ClinicDetailPageFlexible/components/BookModule/components/shared/Header';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

const Root = styled.form.withConfig({ componentId: 'sc-1wbsri4-0' })`
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 0 auto;
`;

const ContentContainer = styled.div.withConfig({ componentId: 'sc-1wbsri4-1' })`
  width: 90%;
  margin: 0 auto;
`;

const StyledBox = styled(Box).withConfig({ componentId: 'sc-1wbsri4-2' })`
  background-color: #fffdfe;
`;

type Props = {
  children: ReactNode;
  title: string;
  variant: ModuleVariant;
};

export const moduleRootBoxName = 'moduleRootBox';

const ModuleRoot = ({ children, title, variant }: Props) => {
  const flags = useLDFlags();

  if (!flags.kis511H22022BookingFlow) {
    return (
      <Box borderRadius="xl" boxShadow="xs" className={moduleRootBoxName}>
        <Root data-testid={dataTestIds.cdp.bookModuleRoot}>
          <ContentContainer>
            <Header title={title} />
            {children}
          </ContentContainer>
        </Root>
      </Box>
    );
  }

  const TextWrapper = ({ children }: { children: any }) => {
    if (variant === ModuleVariant.MODAL) {
      return (
        <StyledBox pt={3} textColor="gray-600">
          <ContentContainer>
            <Text variant="h3">{children}</Text>
          </ContentContainer>
        </StyledBox>
      );
    }

    return (
      <StyledBox
        borderBottom={`1px ${palette.gray[200]} solid`}
        borderTopLeftRadius="xl"
        borderTopRightRadius="xl"
        pb={2}
        pt={3}
        textColor="gray-600"
      >
        <ContentContainer>
          <ContentContainer>
            <Text variant="h2">{children}</Text>
          </ContentContainer>
        </ContentContainer>
      </StyledBox>
    );
  };

  return (
    <Box borderRadius="xl" boxShadow="xs" className={moduleRootBoxName}>
      <Root data-testid={dataTestIds.cdp.bookModuleRoot}>
        <TextWrapper>{title}</TextWrapper>
        <ContentContainer>{children}</ContentContainer>
      </Root>
    </Box>
  );
};

export default ModuleRoot;
